import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { of, Subscription, Subject } from 'rxjs';
import { map, switchMap, finalize } from 'rxjs/operators';
import { Title } from "@angular/platform-browser";
import { FilterService } from 'primeng/api';
import { Table, TableFilterEvent } from 'primeng/table';

import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry} from 'src/app/shared/doc-list-entry';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-home-paid-orders-list',
  templateUrl: './home-paid-orders-list.component.html',
  styleUrls: ['./home-paid-orders-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomePaidOrdersListComponent implements OnInit, OnDestroy, OnChanges {

  @Input() today: Date;
  @Input() clean: boolean = true;

  globalSettinsData: GlobalSettingsData;

  paidOrdersQuery: Subscription;
  totalRecentPaidOrders: number;
  paidOrdersList: DocListEntry[];
  paidSelectedDocument: DocListEntry;

  loading: boolean = false;

  totalInvoiceSum: number = 0;
  totalPaidSum: number = 0;
  totalPaidNowSum: number = 0;
  totalShippedSum: number = 0;

  filteredInvoiceSum: number = 0;
  filteredPaidSum: number = 0;
  filteredPaidNowSum: number = 0;
  filteredShippedSum: number = 0;

  @ViewChild('ptable3') ptable3: Table;

  cf3: any = {};    // to store f[string] filters value

  constructor(
    private restapi: RestApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
    private titleService: Title,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** HomePaidOrdersListComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      //environment.production || console.log('*** HomePaidOrdersListComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //environment.production || console.log('*** HomePaidOrdersListComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'clean':
          this.clearSavedSettings();

        case 'today':
          this.loadRecentPaidOrdersData();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomePaidOrdersListComponent in ngOnDestroy");

    if (this.paidOrdersQuery) { this.paidOrdersQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** HomePaidOrdersListComponent in ngOnInit");
    this.titleService.setTitle('Оплаченные заказы - домашняя страница');

    let ddd: Date = new Date();

    this.today = new Date();
    //this.today = new Date(ddd.getFullYear(), ddd.getMonth(), ddd.getDate() + 1);

    //this.today = new Date(ddd.getUTCFullYear(), ddd.getUTCMonth(), ddd.getUTCDate(), 23, 59, 59);

    //let jn: Date = new Date();
    //let td: Date = new Date();
    //td.setHours(0, 0, 0, 0);
    //let tm: Date = new Date(td);
    //tm.setHours(23, 59, 59);

    console.log('*** HomePaidOrdersListComponent in onInit: ' + JSON.stringify(this.today));

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.loadRecentPaidOrdersData();
  }

  docListCalculatedFields(orderList: DocListEntry[]) {

    let jn: Date = new Date();
    let td: Date = new Date();
    td.setHours(0, 0, 0, 0);
    let tm: Date = new Date(td);
    tm.setHours(23, 59, 59);

    orderList.forEach((dc: DocListEntry) => {
      dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

      dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

      dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

      dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

      dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

      dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

      dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

      dc.fd = (new Date(dc.DOCDATE) > tm);
    });
  }

  loadRecentPaidOrdersData() {
    if (this.globalSettinsData) {
      this.loading = true;
      this.paidOrdersQuery =
        of({ mc: this.globalSettinsData.mainCompanyId, depth: 1, date: this.today })
        .pipe(
          switchMap(opt => this.restapi.getDailyPaidOrdersList(opt.mc, opt.depth, opt.date).pipe(
            map(data => {
              this.paidOrdersList = data || [];
              this.totalRecentPaidOrders = this.paidOrdersList.length;
              this.docListCalculatedFields(this.paidOrdersList);
            }),
            finalize(() => {
              this.totalInvoiceSum = this.paidOrdersList.reduce((s, e) => s += e.DOCSUM, 0);
              this.totalPaidSum = this.paidOrdersList.reduce((s, e) => s += e.PAYDSUM, 0);
              this.totalPaidNowSum = this.paidOrdersList.reduce((s, e) => s += e.PAIDJUSTNOW, 0);
              this.totalShippedSum = this.paidOrdersList.reduce((s, e) => s += e.SHIPSUM, 0);
              this.loading = false;
            })
          )))
          .subscribe();
    }
  }

  onFilterEvent(event: TableFilterEvent) {
    console.log('*** HomePaidOrdersListComponent onFilterEvent: ' + JSON.stringify(event));

    this.totalInvoiceSum = event.filteredValue.reduce((s, e) => s += e.DOCSUM, 0);
    this.totalPaidSum = event.filteredValue.reduce((s, e) => s += e.PAYDSUM, 0);
    this.totalPaidNowSum = event.filteredValue.reduce((s, e) => s += e.PAIDJUSTNOW, 0);
    this.totalShippedSum = event.filteredValue.reduce((s, e) => s += e.SHIPSUM, 0);

    //  this.filteredInvoiceSum = event.filteredValue.reduce((s, e) => s += e.DOCSUM, 0);
    //  this.filteredPaidSum = event.filteredValue.reduce((s, e) => s += e.PAYDSUM, 0);
    //  this.filteredPaidNowSum = event.filteredValue.reduce((s, e) => s += e.PAIDJUSTNOW, 0);
    //  this.filteredShippedSum = event.filteredValue.reduce((s, e) => s += e.SHIPSUM, 0);
  }

  onPaidRowSelect(event) {
    //console.log('*** DocumentsComponent onRowSelect: ' + JSON.stringify(event.data))
    //this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCID });
    //    this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCTYPEID });

    //this.selectedDocumentId = event.data.DOCID;
    //if (this.selectedDocumentId) {
    //  //this.doLoadDataItems(this.selectedDocumentId);
    //}
  }

  onStateSave(state) {
    console.log('*** HomePaidOrdersListComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestorePaid(state) {
    console.log('*** HomePaidOrdersListComponent onStateRestoreNew: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf3[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
      }
    }
  }

  clearSavedSettings() {
    console.log('*** HomePaidOrdersListComponent in clearSavedSettings: ' + this.clean);
    try {
      this.ptable3.clearState();

      for (let f in this.cf3) {
        this.cf3[f] = "";
      }

    } catch (e) {
      console.log('*** HomePaidOrdersListComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
    this.clean = false;
  }

  reloadTable(event) {
    console.log('*** HomePaidOrdersListComponent reloadTable: ' + JSON.stringify(event));

    this.loadRecentPaidOrdersData();
  }

  clearOrResetTableFilter(event) {
    console.log('*** HomePaidOrdersListComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.clearSavedSettings();
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** HomePaidOrdersListComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.paidOrdersList);

      const exportData: any =
        this.paidOrdersList.map(e => ({

          'Документ': e.DOCNAME,
          'Номер': e.DOCNUMBER,
          'Дата': new Date(e.DOCDATE),
          'Покупатель': e.CLIENTSNAME,
          'Ответственный': e.PERSONNAME,
          'Продавец': e.LOCALCOMP,
          'Менеджер': e.AUTHOR,
          'Сумма': e.DOCSUM,
          'Оплачено': e.PAYDSUM,
          'Отгружено': e.SHIPSUM,
          'Валюта': e.CURSTR,
          'Курс': e.DOCRATEVAL,
          'Примечание продавца': e.DOCNOTE1,
          'Примечание покупателя': e.DOCNOTE2,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { documents: worksheet }, SheetNames: ['documents'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "documents");
    });
  }
}
